/* eslint-disable new-cap */
import {MobxReactionUpdate} from '@adobe/lit-mobx';
import {LitElement, html} from 'lit';
import styles from './tooltip.component.scss?as=stylesheet';
import {defineCustomElement} from 'extensions/utils';

class Tooltip extends MobxReactionUpdate(LitElement) {
	static get styles () {
		return [styles];
	}

	static get properties () {
		return {
			code: {
				type: String
			},
			endpoint: {
				type: String
			},
			label: {
				type: String
			},
			title: {
				type: String
			}
		};
	}

	constructor () {
		super();
		this.label = 'Learn More';
	}

	get target () {
		return `${this.endpoint}get=load-tooltip&Tooltip_Code=rb-tooltip-${this.code}`;
	}

	render () {
		return html`
			<rb-tooltip-modal type="ajax" target="${this.target}" header="false">
				<a slot="trigger" class="tooltip" href="${this.target}">${this.label}</a>
			</rb-tooltip-modal>
		`;
	}
};

defineCustomElement('rb-tooltip', Tooltip);
